module.exports = __webpack_public_path__ + "img/B相截取.186650cd.png";